import { Component, EventEmitter, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RoleType } from '../../models';
import { LocalCartService } from '../../services/local-cart.service';
import { SharedAccountService } from '../../services/shared-account.service';
import { SharedSessionService } from '../../services/shared-session.service';
import { Logger, LogService } from '../../util';

// Import webview detection service
declare const require: any;
const isWebview = require('is-ua-webview');

@Component({
  selector: 'lib-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  private readonly _logger: Logger;

  currentUserEmail = this.sharedSessionService.userEmail;
  googleOAuthURL = this.sharedAccountService.googleOAuthURL;

  roleType = RoleType;

  @Output() webviewSignInClicked = new EventEmitter<string>();

  constructor(
    private readonly logService: LogService,
    private readonly sharedSessionService: SharedSessionService,
    private readonly sharedAccountService: SharedAccountService,
    private readonly localCartService: LocalCartService,
  ) {
    this._logger = this.logService.createLogger(HeaderComponent.name);
  }

  get isLoggedIn(): boolean {
    return this.sharedSessionService.userInfo ? true : false;
  }

  get isNormalUser(): boolean {
    return this.sharedSessionService.userRole === RoleType.USER;
  }

  get cartTotal(): number {
    // Always use localStorage cart for consistency
    return this.localCartService.cartCount;
  }

  get hasCartItems(): boolean {
    return this.cartTotal > 0;
  }

  // Add webview detection getter - for testing purposes, always return true
  get isWebview(): boolean {
    // TODO_WEBVIEW_TESTING: Change back to real detection for production
    // return true;
    return isWebview(navigator.userAgent);
  }

  getUserImageUrl(): string {
    return `url('${this.sharedSessionService.userImageUrl}')`;
  }

  onOpenLink(target: string) {
    this.redirect(target);
  }

  onOpenLinkNewTab(target: string) {
    window.open(target, '_blank');
  }

  onCartClick(): void {
    // Navigate to cart page - same for both authenticated and guest users
    this.redirect('/app/#/user/cart');
  }

  async onLogout() {
    await this.sharedAccountService.logout();
    this.redirect(environment.frontendAppUrl);
  }

  onWebviewSignInClick(): void {
    // Emit event to trigger global webview auth modal
    this.webviewSignInClicked.emit(window.location.pathname);
  }

  redirect(target: string): void {
    if (target.startsWith('http')) {
      window.location.href = target;
    } else if (target.startsWith('/')) {
      window.location.href = new URL(target, window.location.origin).href;
    } else {
      this._logger.error(`Unknown how to handle:`, target, 'trying as relative URL');
      window.location.href = new URL(target, window.location.origin).href;
    }
  }
}
